import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const APARTMENT_STATUS_MENU = {
  key: ROUTES.APARTMENT_STATUS.ROOT,
  label: TITLES[ROUTES.APARTMENT_STATUS.ROOT],
  environment: [DEV, STAGE, PROD],
};
